export const columns = t => [
  {
    title: t('Invoice #'),
    name: 'invoiceId'
  },
  {
    title: t('Shipment #'),
    name: 'shipmentId'
  },
  {
    title: t('PRO #'),
    name: 'proNumber'
  },
  {
    title: t('GL Code'),
    name: 'glCode'
  },
  {
    title: t('Invoiced'),
    name: 'amountDue'
  },
  {
    title: t('Due Date'),
    name: 'dueDate'
  }
];
export const currencyColumns = ['amountDue'];
export const dateColumns = ['dueDate'];
export default {
  columns,
  currencyColumns,
  dateColumns
};
